import React, { createContext, useContext, useEffect, useRef, useState } from 'react';

const DataEnrichContext = createContext();

export const useEnrichType = () => useContext(DataEnrichContext);

export const EnrichProvider = ({ children }) => {
	// Function to safely retrieve and parse data from local storage
	
	const safeGetFromLocalStorage = (key, defaultValue) => {
		const item = localStorage.getItem(key);
		
		try {
			return item ? JSON.parse(item) : defaultValue;
		} catch (error) {
			console.error(`Error parsing localStorage item "${key}":`, error);
			return defaultValue; // Return default value on error
		}
	};

	const initialFile = safeGetFromLocalStorage('file', '');
	const initialCompanies = safeGetFromLocalStorage('companies', []);
	const initialPersonaData = safeGetFromLocalStorage('personaData', []);
	const initialEmailVerificationFile = safeGetFromLocalStorage('emailVerificationFile', '');
	
	const initialEmailVerificationData = safeGetFromLocalStorage(
		'emailVerificationData',
		[]
	);
	const initialAccountEnriched = safeGetFromLocalStorage(
		'accountEnriched',
		false
	);
	const initialContactEnriched = safeGetFromLocalStorage(
		'contactEnriched',
		false
	);
	const initialEmailVerification = safeGetFromLocalStorage(
		'emailVerification',
		false
	);

	const initialSelectedSegment = safeGetFromLocalStorage('segment', '');
	const initialDemoAccountEnriched = safeGetFromLocalStorage('demoDataEnriched',false)


	const [file, setFile] = useState(initialFile);
	const [emailFileVerificationFile, setEmailFileVerificationFile] = useState(initialEmailVerificationFile);

	const [accountEnriched, setAccountEnriched] = useState(
		initialAccountEnriched
	);
	const [dropdownOptions, setDropdownOptions] = useState(
		{}
	);
    const [wholeList, setWholeList] = useState([]);
	const [contactEnriched, setcontactEnriched] = useState(
		initialContactEnriched
	);
	const [emailVerification, setEmailVerification] = useState(
		initialEmailVerification
	);
	const [enrichedData, setenrichedData] = useState([]);
	const [contactenrichedData, setcontactenrichedData] = useState(
	[]	
	);
	const shouldSkipApiCallRef = useRef(false);
	const [emailVerificationData, setEmailVerificationData] = useState(
		initialEmailVerificationData
	);
	const [selectedcompanies, setselectedCompanies] = useState(initialCompanies);
	const [personaData, setPersonaData] = useState(initialPersonaData);
	const [segmentList, setSegmentList] = useState([]);
	const [segmentData, setSegmentData] = useState([]);
	const [selectedSegment, setSelectedSegment] = useState();
	const [segment, setSegment] = useState(initialSelectedSegment);
	const [demoDataEnriched, setDemoDataEnriched] = useState(initialDemoAccountEnriched);

	// Save file to local storage when it changes
	useEffect(() => {
		localStorage.setItem('file', file);
	}, [file]);

	useEffect(() => {
		localStorage.setItem('emailVerificationFile', emailFileVerificationFile);
	}, [	emailFileVerificationFile
   ]);

    useEffect(() => {
	localStorage.setItem("segment", JSON.stringify(segment));
   }, [segment]);

    useEffect(() => {
	localStorage.setItem("demoDataEnriched", JSON.stringify(demoDataEnriched));
    }, [demoDataEnriched]);


	// Save companies to local storage when they change
	useEffect(() => {
		localStorage.setItem('companies', JSON.stringify(selectedcompanies));
	}, [selectedcompanies]);

	// Save personaData to local storage when it changes
	useEffect(() => {
		localStorage.setItem('personaData', JSON.stringify(personaData));
	}, [personaData]);

	useEffect(() => {
		localStorage.setItem(
			'emailVerificationData',
			JSON.stringify(emailVerificationData)
		);
	}, [emailVerificationData]);


	// Save accountEnriched state to local storage when it changes
	useEffect(() => {
		localStorage.setItem('accountEnriched', JSON.stringify(accountEnriched));
	}, [accountEnriched]);

	useEffect(() => {
		localStorage.setItem('contactEnriched', JSON.stringify(accountEnriched));
	}, [accountEnriched]);

	useEffect(() => {
		localStorage.setItem('emailVerification', JSON.stringify(emailVerification));
	}, [emailVerification]);

	return (
		<DataEnrichContext.Provider
			value={{
				file,
				setFile,
				setEmailFileVerificationFile,
				emailFileVerificationFile,
				enrichedData,
				setenrichedData,
				contactenrichedData,
				setcontactenrichedData,
				emailVerificationData,
				setEmailVerificationData,
				personaData,
				setPersonaData,
				accountEnriched,
				setAccountEnriched,
				contactEnriched,
				setcontactEnriched,
				emailVerification,
				setEmailVerification,
				selectedcompanies,
				setselectedCompanies,
				segmentList,
				setSegmentList,
				setSegmentData,
				segmentData,
				setWholeList,
				wholeList,
				selectedSegment,
				setSelectedSegment,
				segment,
				setSegment,
				shouldSkipApiCallRef,
				dropdownOptions,
				setDropdownOptions,
				setDemoDataEnriched
			}}
		>
			{children}
		</DataEnrichContext.Provider>
	);
};

export default DataEnrichContext;
